module.exports = __webpack_public_path__ + "static/media/Bookcraft-logo.60e92fdc.png";